<template>
  <div class="visitNoticeSet">
    <el-form ref="form" :model="form" label-width="auto">
      <el-form-item label="开启拜访提醒：">
        <el-switch v-model="form.openNotice" @change="updateInfo"></el-switch>
      </el-form-item>
      <el-form-item label="业务员提醒：">
        <el-input-number v-model="form.managerNoticeDay" @blur="updateInfo" step-strictly :controls="false"/> 天
      </el-form-item>
      <el-form-item label="部门负责人提醒：">
        <el-input-number v-model="form.masterNoticeDay" @blur="updateInfo" step-strictly :controls="false"/> 天
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {getVisitNoticeSetInfo,updateVisitNoticeSetInfo} from "~/api/axiosInfo"
export default {
  data(){
    return {
      form:{
        openNotice: false,
        managerNoticeDay: null,
        masterNoticeDay: null,
      },
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      getVisitNoticeSetInfo().then(res=>{
        if(res){
          this.form = res
        }
      }).catch(err=>{

      })
    },

    updateInfo(){
      updateVisitNoticeSetInfo(this.form).then(res=>{
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
      }).catch(err=>{

      })
    },
    
  },
}
</script>

<style lang="less">
.visitNoticeSet{

}
</style>